import type { FC } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import type { Location__Fact, PageQuery } from '@graphql/platform';

import { PageContent, PageSectionText, PageSectionTitle } from './shared';

const PageFactsContainer = styled.div`
  color: ${COLORS.cloud};
  background: ${COLORS.tealPrimary};
  ${mq({
    padding: ['24px 18px', '24px'],
  })}
`;

const PageFactsContent = styled(PageContent)`
  display: flex;
  align-items: center;
  text-align: center;
  ${mq({
    flexDirection: ['column', null, 'row'],
    gap: ['24px', null, '55px'],
    padding: ['0 !important', null, '0 50px 0 0 !important'],
  })}
`;

const PageFactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${mq({
    width: ['233px', '1280px'],
    height: ['90px', 'auto'],
    flexGrow: [0, 1],
    flexShrink: [0, 1],
    flexBasis: ['auto', 0],
  })}
`;

const PageFactTitle = styled(PageSectionTitle)`
  && {
    ${mq({
      fontSize: ['40px', '40px'],
      lineHeight: ['44px', '44px'],
    })}
  }
`;

const PageFactDescription = styled(PageSectionText)`
  && {
    font-size: 18px;
    line-height: 1.2;
  }
`;

const PageFact: FC<{
  fact: Pick<Location__Fact, 'title' | 'description'>;
}> = ({ fact }) => (
  <PageFactContainer>
    <PageFactTitle>{fact.title}</PageFactTitle>
    <PageFactDescription>{fact.description}</PageFactDescription>
  </PageFactContainer>
);

export const PageFacts: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  return (
    <PageFactsContainer>
      <PageFactsContent>
        {page.facts.map((fact, key) => (
          <PageFact key={key} fact={fact} />
        ))}
      </PageFactsContent>
    </PageFactsContainer>
  );
};
